import React from "react";
import OrdersHistory from "../../components/OrdersHistory/OrdersHistory";
import { useOrdersHistory } from "./useOrdersHistory";
import { OrdersHistoryFilterValue } from "../../components/OrdersHistory/OrdersHistoryFilter/OrdersHistoryFilter";

const OrdersHistoryPage: React.FC = () => {
  const [filter, setFilter] =
    React.useState<OrdersHistoryFilterValue>("last3months");

  const {
    items,
    totalItems,
    canLoadMore,
    isLoading,
    isFetchingMore,
    loadMore,
  } = useOrdersHistory(filter);
  return (
    <OrdersHistory
      items={items}
      totalItems={totalItems}
      canLoadMore={canLoadMore}
      isLoading={isLoading}
      isFetchingMore={isFetchingMore}
      loadMore={loadMore}
      filter={filter}
      setFilter={setFilter}
    />
  );
};

export default OrdersHistoryPage;
